import Vue from "vue";

export const log = {
  info: (...args: any[]) => Vue.$log.info(...args),
  debug: (...args: any[]) => Vue.$log.debug(...args),
  error: (...args: any[]) => Vue.$log.error(...args)
};
